import { AccountingClass } from "./accounting-class";
import { ChartOfAccount } from "./chart-of-account";
import { CoaTransactionDetail } from "./coa-transaction-detail";
import { SystemField } from "./system-field";

export class CoaTransactionSummary extends SystemField{
  
    class_type?:string;
    trans_date?:string;
    total_amount?:number;
    total_credit?:number;
    total_debit?:number;
    coa_id?:string;
    ledger_id?:string;
    branch_id?:string;
    acc_cls_id?:string;

    //formula fields
    begin_balance?:number;
    ending_balance?:number;
    fin_period?:string;

    //relationship
    details?:CoaTransactionDetail;
    chart_of_account?:ChartOfAccount;
    account_class?:AccountingClass;
}
